import React from 'react';

import { Fab } from '@material-ui/core';

export default class ACButtonIcon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const spanMargin = this.props.spanMargin || '0 0px';

    let values = [
      <span
        key={this.props.id}
        style={{
          margin: spanMargin,
        }}
      >
        {this.props.text}
      </span>,
    ];

    if (this.props.icon) {
      const icon = this.props.icon;

      if (!this.props.iconLast) {
        values.unshift(icon);
      } else {
        values.push(icon);
      }
    }

    const backgroundColor = this.props.backgroundColor || 'white';
    const color = this.props.color || '#78828a';
    const fontSize = this.props.fontSize || '12px';
    const padding = this.props.padding || '2px 2px';
    const border = this.props.border || '';
    const margin = this.props.margin || '';

    return (
      <Fab
        key={this.props.id}
        variant="extended"
        size="small"
        style={{
          backgroundColor: backgroundColor,
          color: color,
          fontSize: fontSize,
          boxShadow: '0 0',
          textTransform: 'none',
          padding: padding,
          border: border,
          margin: margin,
        }}
        className={this.props.className}
        onClick={this.props.onClickFunc}
        disabled={this.props.disabled}
      >
        {values}
      </Fab>
    );
  }
}
